module.exports = __webpack_public_path__ + "media/images/twitter-icon-a5b83e571fd575f67e760268fb14c6a4.png";